import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files`;

export interface DeleteFileCommentCommandPayload {
  fileCommentId: string;
}

export const deleteFileCommentRequest = (
  payload: DeleteFileCommentCommandPayload,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.fileCommentId}/fileComment`,
  config: { method: SUPPORTED_METHODS.DELETE },
});

export const deleteFileCommentCommand = async (
  payload: DeleteFileCommentCommandPayload,
): Promise<BaseBackResponse> => {
  try {
    return await executeQuery<BaseBackResponse>(
      deleteFileCommentRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
